import { createSlice } from "@reduxjs/toolkit";
import { fetchVrImages } from "./vrImageBaseApi";

const vrImagesSlice = createSlice({
  name: "vrImages",
  initialState: {
    vrImages: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVrImages.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVrImages.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vrImages = action.payload;
      })
      .addCase(fetchVrImages.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
  },
});

export default vrImagesSlice.reducer;
